/* 文字盤の検索（テーマ側）。Shopify標準の検索は日本語をばらばらに区切るのでほぼ全件当たり、入力中の候補も動かない（417）。
   そこで、全商品の名前と、カテゴリ表から作ったキーワード（大・中・小カテゴリ）で探す。
   ・ひらがな／カタカナ／全角半角の違いは無視する。犬→いぬ、柴犬→しば犬 のような言い換えも見る
   ・並びは「名前に入っているもの」が先、同じなら売れている順
   ・検索窓（name="q"）には、入力中に候補を出す。検索結果のページ（hf-search-results）もこれを使う */
(function(){
  var ALIAS = {
    '犬':'いぬ','いぬ':'犬','猫':'ねこ','ねこ':'猫','鳥':'とり','とり':'鳥','兎':'うさぎ','柴犬':'しば犬','柴':'しば','しばいぬ':'しば犬',
    '熊':'くま','くま':'熊','魚':'さかな','さかな':'魚','牛':'うし','馬':'うま','羊':'ひつじ','豚':'ぶた','狐':'きつね','狸':'たぬき',
    '鹿':'しか','蛙':'かえる','かえる':'がえる','亀':'かめ','蛇':'へび','象':'ぞう','虎':'とら','鯨':'くじら','鮫':'さめ','海豚':'いるか',
    'きんぎょ':'金魚','金魚':'きんぎょ','ふくろう':'ふくろう','梟':'ふくろう','恐竜':'恐竜','きょうりゅう':'恐竜','花':'はな','はな':'花',
    'すし':'寿司','寿司':'すし','ぱん':'パン','コーヒー':'珈琲','珈琲':'こーひー','インコ':'いんこ','文鳥':'ぶんちょう','ぶんちょう':'文鳥',
    'ダックス':'だっくすふんど','トイプー':'といぷーどる','シュナ':'しゅなうざー','ポメ':'ぽめらにあん','フレブル':'ふれんちぶるどっぐ',
    'ゴールデン':'ごーるでんれとりばー','ラブ':'らぶらどーる','コーギー':'こーぎー','ハスキー':'しべりあんはすきー',
    // カテゴリの呼び名
    '海':'海・水辺のいきもの','水族館':'海・水辺のいきもの','水辺':'海・水辺のいきもの','動物園':'動物園・野生動物','野生動物':'動物園・野生動物',
    '小動物':'うさぎ・小動物','たべもの':'たべもの・のみもの','食べ物':'たべもの・のみもの','のみもの':'たべもの・のみもの','飲み物':'たべもの・のみもの',
    'しゅみ':'しゅみ・自然','趣味':'しゅみ・自然','UMA':'UMA・ふしぎ','uma':'UMA・ふしぎ','ゆーま':'UMA・ふしぎ'
  };
  var SKIP = {'repair':1,'warranty-exchange':1,'belt':1,'belt2':1};
  function norm(s){
    s = String(s || '').normalize('NFKC').toLowerCase();
    // カタカナ → ひらがな
    s = s.replace(/[ァ-ヶ]/g, function(c){ return String.fromCharCode(c.charCodeAt(0) - 0x60); });
    return s.replace(/[\s・（）()「」『』、。,.\-_/]/g, '');
  }
  var data = null, loading = null;
  function load(){
    if (data) return Promise.resolve(data);
    if (loading) return loading;
    var KEY = 'hf-search-v3';
    try { var c = JSON.parse(sessionStorage.getItem(KEY) || 'null'); if (c && Date.now() - c.at < 30 * 60 * 1000){ data = c.d; return Promise.resolve(data); } } catch(e){}
    var base = '/collections/all?view=hf-index&sort_by=best-selling&page=';
    var kwUrl = (document.querySelector('script[data-hf-search-kw]') || {}).getAttribute ? document.querySelector('script[data-hf-search-kw]').getAttribute('data-hf-search-kw') : null;
    var get = function(u){ return fetch(u, {credentials: 'same-origin'}).then(function(r){ return r.ok ? r.text() : '[]'; }).then(function(t){ try { return JSON.parse(t); } catch(e){ return []; } }); };
    loading = Promise.all([get(base + 1), get(base + 2), kwUrl ? fetch(kwUrl).then(function(r){ return r.json(); }).catch(function(){ return {}; }) : Promise.resolve({})]).then(function(res){
      var seen = {}, list = [];
      res[0].concat(res[1]).forEach(function(p, i){
        if (!p || seen[p.h] || SKIP[p.h]) return; seen[p.h] = 1;
        var kw = res[2][p.h] || [];
        p.rank = i; p.nt = norm(p.t); p.nc = kw.map(norm); p.nk = norm(kw.join(' ') + ' ' + (p.g || ''));
        list.push(p);
      });
      data = list;
      try { sessionStorage.setItem(KEY, JSON.stringify({at: Date.now(), d: list})); } catch(e){}
      return data;
    });
    return loading;
  }
  function alts(tok){
    var a = [norm(tok)], al = ALIAS[tok] || ALIAS[norm(tok)];
    if (al) a.push(norm(al));
    return a;
  }
  // 当たり方の強さ：種類名か大カテゴリ名とぴったり110（「とり」で鳥を先に）／名前の先頭100／名前の途中70／カテゴリ名とぴったり同じ60（「犬」でいぬ全部）／カテゴリ名やタグの一部30。
  // 名前かカテゴリ名ぴったりで当たるものがあれば、一部だけ当たったもの（「うさぎ」で うさぎ・小動物 のハムスター など）は出さない
  function search(q){
    var toks = String(q || '').trim().split(/\s+/).filter(Boolean);
    if (!toks.length || !data) return [];
    var groups = toks.map(alts), out = [], top = 0;
    data.forEach(function(p){
      var score = 0, tier = 999;
      for (var i = 0; i < groups.length; i++){
        var best = 0;
        groups[i].forEach(function(t){
          if (!t) return;
          if (p.nc[0] === t || p.nc[2] === t) best = Math.max(best, 110);
          if (p.nt.indexOf(t) === 0) best = Math.max(best, 100);
          else if (p.nt.indexOf(t) > 0) best = Math.max(best, 70);
          else if (p.nc.indexOf(t) >= 0) best = Math.max(best, 60);
          else if (p.nk.indexOf(t) >= 0) best = Math.max(best, 30);
        });
        if (!best) return;
        score += best; tier = Math.min(tier, best);
      }
      top = Math.max(top, tier);
      out.push({p: p, s: score, t: tier});
    });
    if (top >= 60) out = out.filter(function(x){ return x.t >= 60; });
    out.sort(function(a, b){ return b.s - a.s || a.p.rank - b.p.rank; });
    return out.map(function(x){ return x.p; });
  }
  function dial(p, size){
    if (!p.i) return '';
    var cw = Math.round(p.w * 0.4), half = Math.floor(cw / 2);
    return p.i + '&crop=region&crop_left=' + (Math.round(p.w * 0.501) - half) + '&crop_top=' + (Math.round(p.ht * 0.503) - half) + '&crop_width=' + cw + '&crop_height=' + cw + '&width=' + size;
  }
  var esc = function(s){ return String(s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); };

  // 入力中の候補（検索窓の下に最大6件）
  function attach(input){
    if (input.dataset.hfSuggest) return; input.dataset.hfSuggest = '1';
    var form = input.form; if (!form) return;
    form.style.position = form.style.position || 'relative';
    var box = document.createElement('div'); box.className = 'hf-sug'; box.hidden = true; box.setAttribute('role', 'listbox');
    form.appendChild(box);
    var timer;
    function render(){
      var q = input.value;
      if (!q.trim()){ box.hidden = true; return; }
      load().then(function(){
        var r = search(q), top = r.slice(0, 6);
        if (!top.length){ box.innerHTML = '<p class="hf-sug__none">「' + esc(q) + '」に当てはまる文字盤はありません</p>'; box.hidden = false; return; }
        box.innerHTML = top.map(function(p){
          return '<a class="hf-sug__item" role="option" href="' + esc(p.u) + '"><img src="' + esc(dial(p, 96)) + '" alt="" width="40" height="40" loading="lazy"><span>' + esc(p.t) + '</span></a>';
        }).join('') + '<button type="submit" class="hf-sug__all">「' + esc(q) + '」の文字盤をすべて見る（' + r.length + '点）</button>';
        box.hidden = false;
      });
    }
    input.addEventListener('focus', function(){ load(); });
    input.addEventListener('input', function(){ clearTimeout(timer); timer = setTimeout(render, 120); });
    input.addEventListener('keydown', function(e){ if (e.key === 'Escape') box.hidden = true; });
    document.addEventListener('click', function(e){ if (!form.contains(e.target)) box.hidden = true; });
  }
  function attachAll(){ document.querySelectorAll('form[action*="/search"] input[name="q"]').forEach(attach); }
  window.hfSearch = {load: load, search: search, dial: dial, esc: esc};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', attachAll); else attachAll();
  // ヘッダーの検索は開いたときに作られることがあるので、開いたときにもう一度つなぐ
  document.addEventListener('click', function(){ setTimeout(attachAll, 50); });
})();
